import { CountryModel } from "./country.model";

export class TargetingModel {
  countries_ids: any[];
  cities_ids: any[];
  institutes_ids: any[];
  study_tags_ids: any[];
  macro_study_tags_ids: any[];

  countries: CountryModel[];
  cities: any[];
  macro_study_tags: any[];
  study_tags: any[];
  institutes: any[];

  constructor(target: any = null) {
    // FIX-ME convert target

    if (target) {
      console.log(target);
      this.countries = target.countries;
      this.cities = target.cities;
      this.macro_study_tags = target.macro_study_tags;
      this.macro_study_tags.map((mst) => {
        if (mst.name_en && !mst.name) {
          return (mst.name = mst.name_en);
        } else if (!mst.name_en && mst.name) {
          return (mst.name_en = mst.name);
        }
        // mst.name = mst.name_en
      });

      this.study_tags = target.study_tags;
      this.study_tags.map((st) => {
        if (st.name_en && !st.name) {
          return (st.name = st.name_en);
        } else if (!st.name_en && st.name) {
          return (st.name_en = st.name);
        }
      });

      this.institutes = target.institutes;
      console.log(this.institutes, target.institutes);

      this.countries_ids = target.countries_ids.map((id) => {
        if (typeof id === "number") {
          return target.countries.filter((c) => c.id === id)[0];
        } else {
          return target.countries.filter((c) => c.id === id.id)[0];
        }
      });
      this.macro_study_tags_ids = target.macro_study_tags_ids.map((id) => {
        // target.macro_study_tags.filter(mst => mst.id === id)[0]
        if (typeof id === "number") {
          return target.macro_study_tags.filter((mst) => mst.id === id)[0];
        } else {
          return target.macro_study_tags.filter((mst) => mst.id === id.id)[0];
        }
      });
      this.study_tags = this.study_tags_ids = target.study_tags_ids.map(
        (id) => {
          if (typeof id === "number") {
            return (
              target.study_tags.filter((st) => st.id === id)[0] ||
              target.study_tags_ids.filter((st) => st.id === id)[0]
            );
          } else {
            return (
              target.study_tags.filter((st) => st.id === id.id)[0] ||
              target.study_tags_ids.filter((st) => st.id === id.id)[0]
            );
          }
        }
      );

      // try {
      //   this.macro_study_tags_ids.map(mst => mst.name = mst.name_en || mst.name);
      //   this.study_tags_ids.map(st => st.name = st.name_en || st.name);
      // } catch(e) {
      //   console.log('Cannot map');
      // }

      this.cities_ids = target.cities_ids.map((id) => {
        if (typeof id === "number") {
          return target.cities.filter((c) => c.id === id)[0];
        } else {
          return target.cities.filter((c) => c.id === id.id)[0];
        }
      });
      this.institutes = this.institutes_ids = target.institutes_ids.map(
        (id) => {
          if (typeof id === "number") {
            console.log("type number");
            return (
              target.institutes.filter((i) => {
                console.log("institutes", i, i.id, id);
                return i.id === id;
              })[0] ||
              target.institutes_ids.filter((i) => {
                console.log("institutes_ids", i, i.id, id);
                return i.id === id;
              })[0]
            );
          } else {
            console.log("type string");
            return (
              target.institutes.filter((i) => {
                console.log("institutes", i, i.id, id, id.id);
                return i.id === Number(id);
              })[0] ||
              target.institutes_ids.filter((i) => {
                console.log("institutes_ids", i, i.id, id, id.id);
                return i === id;
              })[0]
            );
          }
        }
      );
      console.log(this.institutes, this.institutes_ids, target.institutes);
    } else {
      this.countries_ids = [
        // {
        //   id: 1,
        //   name: "Italy",
        // },
      ];
      this.cities_ids = [];
      this.institutes_ids = [];
      this.study_tags_ids = [];
      this.macro_study_tags_ids = [];
      this.countries = [
        // {
        //   id: 1,
        //   name: "Italy",
        // },
      ];
      this.cities = [];
      this.macro_study_tags = [];
      this.study_tags = [];
      this.institutes = [];
      this.institutes_ids = [];
    }

    // console.log(target, this)
  }
}

export class TargetingRequestModel {
  countries_ids: number[];
  cities_ids: number[];
  institutes_ids: number[];
  study_tags_ids: number[];
  macro_study_tags_ids: number[];
  faculty_tags: string[];
  course_tags: string[];

  constructor() {
    this.countries_ids = [];
    this.cities_ids = [];
    this.institutes_ids = [];
    this.study_tags_ids = [];
    this.macro_study_tags_ids = [];
    this.faculty_tags = [];
    this.course_tags = [];
  }
}

export enum TargetingState {
  SUGGESTED = "suggested",
  ADDED = "added",
  COMPOSE = "compose",
}
